"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const repeat_js_1 = require("lit/directives/repeat.js");
require("@/components/common");
require("@/components/layouts/app-sidebar/sidebar-page-link");
require("@/components/layouts/app-sidebar/sidebar-section");
require("@/components/layouts/app-sidebar/sidebar-user-menu");
const sidebar_styles_1 = require("@/components/layouts/app-sidebar/sidebar.styles");
const constants_1 = require("@/constants");
const disclosure_controller_1 = require("@/controllers/disclosure-controller");
const escape_key_controller_1 = require("@/controllers/escape-key-controller");
const media_query_controller_1 = require("@/controllers/media-query-controller");
const sitemap_1 = require("@/sitemap");
const utils_1 = require("@/utils");
const open_state_1 = require("@/utils/open-state");
const storage_1 = require("@/utils/storage");
const standaloneNodes = sitemap_1.SITEMAP.filter((node) => node.type === 'standalone');
const groupNodes = sitemap_1.SITEMAP.filter((node) => node.type === 'group');
const hasChildren = (node) => !!node.children?.length;
let Sidebar = class Sidebar extends (0, open_state_1.withOpenState)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.currentPageId = (0, utils_1.getCurrentPageId)();
        this.disclosure = new disclosure_controller_1.DisclosureController(this);
        this.escapeKey = new escape_key_controller_1.EscapeKeyController(this);
        // 좁은 화면에서는 열린 채로 본문을 가리지 않도록, 연결될 때와 좁아질 때 닫는다.
        this.mobileQuery = new media_query_controller_1.MediaQueryController(this, constants_1.MEDIA_QUERY.default, matches => {
            if (matches)
                this.close();
        });
        this.renderStandalone = (node) => {
            if (hasChildren(node))
                return this.renderSection(node);
            return (0, lit_1.html) `
      <mm-sidebar-page-link
        href="${node.id}.html"
        label=${node.title}
        icon=${node.icon}
        @click=${this.handlePageLinkClick}
      ></mm-sidebar-page-link>
    `;
        };
        this.renderSection = (node) => (0, lit_1.html) `
    <mm-sidebar-section
      label=${node.title}
      icon=${node.icon}
      ?open=${this.containsCurrentPage(node)}
    >
      ${(0, repeat_js_1.repeat)(node.children ?? [], item => item.id, this.renderItemLink)}
    </mm-sidebar-section>
  `;
        this.renderGroup = (node) => {
            const headingId = `sidebar-group-${node.id}`;
            return (0, lit_1.html) `
      <div class="group">
        <mm-heading level="5" id=${headingId}>${node.title}</mm-heading>
        <mm-list-item-group gap="0" aria-labelledby=${headingId}>
          ${(0, repeat_js_1.repeat)(node.items, item => item.id, this.renderItemLink)}
        </mm-list-item-group>
      </div>
    `;
        };
        this.renderItemLink = (item) => (0, lit_1.html) `
    <mm-sidebar-page-link
      emoji="#"
      href="${item.id}.html"
      label=${item.name}
      @click=${this.handlePageLinkClick}
    ></mm-sidebar-page-link>
  `;
    }
    render() {
        return (0, lit_1.html) `
      <nav>
        <mm-scroll direction="column" gap="4">
          <mm-list-item-group gap="0">
            ${(0, repeat_js_1.repeat)(standaloneNodes, node => node.id, this.renderStandalone)}
          </mm-list-item-group>
          ${(0, repeat_js_1.repeat)(groupNodes, node => node.id, this.renderGroup)}
        </mm-scroll>
        <mm-sidebar-user-menu
          name="soojubm"
          description="soojubm.github.io"
          avatar-src="/src/images/soojubm.png"
        ></mm-sidebar-user-menu>
      </nav>
    `;
    }
    firstUpdated() {
        this.restoreScrollPosition();
    }
    updated(changedProperties) {
        // 닫힌 사이드바로 포커스가 들어가지 않도록 열림 상태에 맞춰 inert를 맞춘다.
        if (changedProperties.has('open'))
            this.inert = !this.open;
    }
    restoreScrollPosition() {
        const saved = (0, storage_1.readStorage)('sidebarScroll');
        if (saved && this.scrollEl)
            this.scrollEl.scrollTop = Number(saved);
    }
    handlePageLinkClick() {
        this.saveScrollPosition();
    }
    saveScrollPosition() {
        (0, storage_1.writeStorage)('sidebarScroll', String(this.scrollEl?.scrollTop ?? 0));
    }
    containsCurrentPage(node) {
        if (node.id === this.currentPageId)
            return true;
        return (node.children ?? []).some(item => item.id === this.currentPageId);
    }
};
Sidebar.styles = [sidebar_styles_1.sidebarStyles];
__decorate([
    (0, decorators_js_1.query)('mm-scroll')
], Sidebar.prototype, "scrollEl", void 0);
Sidebar = __decorate([
    (0, decorators_js_1.customElement)('mm-sidebar')
], Sidebar);
exports.Sidebar = Sidebar;
//# sourceMappingURL=data:application/json;base64,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